import React, { useState, useEffect } from 'react';
import Hero from '../../components/hero/hero';
import Layout from '../../components/layout/layout';
import CarPreview from "../../components/carPreview/carPreview";
import { BASENAME } from "../../constant";
import {isMobile} from 'react-device-detect';

import styles from "./style.module.scss";
import { ajaxGet, ajaxPost } from "../../helper/ajax";
import { translate, translateValue } from '../../helper/functions';


export default function Porsche() {
    const [porscheList, setporscheList] = useState([]);

    const renderCheckList = (val) => {
        return (
            <div className={styles.checkList}>
                <img style={{marginLeft:25}} src="site_images/svg/Check.svg"/>
                <h4>{val}</h4>
            </div>
        )
    }



    useEffect(() => {
        let formdata = new FormData();
        formdata.append("brand", "PORSCHE");
        ajaxPost("getVclList.php", formdata).then((response) => {
            if (response.code == "100") {
                setporscheList(response.message.car)
            }
        });
    }, [])


    return (
        <Layout>
            <div className={styles.contentContainer}>
                <h1 className={styles.pageTitle}>{translate("PorscheTitolo")}</h1>
            <Hero
                onlyBreadcrumb={true}
                breadcrumb={[
                    { label: translate("PorschePath01"), link: BASENAME },
                    { label: translate("PorschePath02"), link: null }
                ]}
                />
            </div>
            <div className={styles.contentContainer} style={{ backgroundColor:"#D8DEE9"}}>
                <div className={styles.content}>
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-4 text-lg-end">
                            <h2 dangerouslySetInnerHTML={{ __html: translate("Porsche01Testo01") }} />
                        </div>
                        <div className="col-12 col-lg-8">
                            <p dangerouslySetInnerHTML={{ __html: translate("Porsche01Testo02") }} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.contentContainer} style={{ backgroundColor: "#D8DEE9", position:"relative" }}>

                <div className={styles.content}>
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-6" >
                            <img src={translateValue("Porsche01Img01")} className={styles.porscheImage}/>
                        </div>
                        <div className="col-12 col-lg-6">
                            <div className="row align-items-center">
                                <div className="col-5 col-md-4">
                                    <img src={translateValue("Porsche01Img02")} className={styles.porscheLogo}  />
                                </div>
                                <div className="col-7 col-md-8">
                                    <div className={styles.checkListContainer}>
                                        {translate("Porsche01Testo03").split("|").map((el) => {
                                            return renderCheckList(el) 
                                            
                                        })}


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.contentContainer}>
            <div className={styles.content}>
                    <h2>{porscheList.length} veicoli <h2 style={{ display: "inline" }} dangerouslySetInnerHTML={{ __html: translate("Porsche02Testo01") }} /></h2>

                    <div className="row">
                        {porscheList.map((el, i) => {
                            return (
                                <div className={"col-12 col-md-4 col-lg-3 my-3"}>
                                    <CarPreview data={el} key={"car-preview-" + i} />
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </Layout>
    );
}

